import axios from "axios";
import { entities } from "../config/config.dataExplorer";
import { API_URL } from "../config/config.data";

export const parseProjectsFromBasins = (basins) => {
    let projects = [];
    for (const basin in basins) {
        projects = [...projects, ...basins[basin]];
    }
    return projects
}

export const getProjectPeople = (project_id) => {
    const url = API_URL + `/${entities.projects.endpoint}/${project_id}/people`
    return axios.get(url)
}
